import { ReactNode } from 'react';
import { ExamTaskGroupSolutionDownloadSignalR } from '../models/examTaskGroupSolutionDownloadSignalR.types';
import { createSignalRContext } from 'react-signalr';
import { SignalRCustomProvider } from './SignalRCustom.context';
import EnvWindow from '../utils/env';

export const ExamTaskGroupSolutionDownloadSignalRContext = createSignalRContext<ExamTaskGroupSolutionDownloadSignalR>({
  shareConnectionBetweenTab: true,
});

export const ExamTaskGroupSolutionDownloadProvider: React.FC<{
  children: ReactNode;
  disabled?: boolean;
  onConnectionChanged?: (connected: boolean) => void;
}> = ({ children, disabled, onConnectionChanged }) => {
  return (
    <SignalRCustomProvider<ExamTaskGroupSolutionDownloadSignalR>
      context={ExamTaskGroupSolutionDownloadSignalRContext}
      url={EnvWindow.REACT_APP_SCORING__WEBSOCKET_URL}
      disabled={disabled}
      onConnectionChanged={onConnectionChanged}
    >
      {children}
    </SignalRCustomProvider>
  );
};
